module.exports = __webpack_public_path__ + "operace-nosu_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_5_after.jpg
// module id = 1137
// module chunks = 0